/**
 * Utilitários puros de busca e ordenação para listas exibidas ao usuário
 * (lista de Elos, preferências de notificação etc.). Nada aqui toca em dados
 * persistidos: a ordem e o filtro valem só para a exibição.
 */

/** Normaliza para comparação: ignora maiúsculas/minúsculas e acentos (busca amigável). */
export function normalizarBusca(texto: string): string {
  return texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
}

/**
 * Comparador para ordem alfabética em português (A→Z). Usa o nome exibido ao
 * usuário e trata acentos e maiúsculas/minúsculas como o dicionário (ex.:
 * "Água" fica junto de "A", não depois de "Z").
 */
export function compararPtBr(a: string, b: string): number {
  return a.localeCompare(b, "pt-BR", { sensitivity: "base" });
}
